import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)

type dayJsInput = string | number | Date | dayjs.Dayjs | undefined

export function validDate(value: dayJsInput): boolean {
  return (
    !!value &&
    !dayjs(value).isSame('01/01/1900', 'day') &&
    !dayjs(value).isSame('01/01/1901', 'day') &&
    dayjs(value).isValid()
  )
}

// Date
export function formatDateValue(date: dayJsInput): string {
  // Date for Date Picker
  return validDate(date) ? dayjs(date).format('YYYY-MM-DD') : ''
}
export function formatDisplayDate(date: dayJsInput, alt?: string): string {
  // Date for Text Field
  return validDate(date) ? dayjs(date).format('L') : alt ? alt : ''
}
// DateTime
export function formatDateTimeValue(date: dayJsInput): string {
  return validDate(date) ? dayjs(date).format('YYYY-MM-DD HH:mm') : ''
}

export function formatDisplayDateTime(date: dayJsInput, alt?: string): string {
  // Date for Text Field
  return validDate(date) ? dayjs(date).format('L LT') : alt ? alt : ''
}
// Time
export function formatTimeValue(time: dayJsInput): string {
  return time ? dayjs(time).format('HH:mm') : ''
}
export function formatDisplayTime(time: dayJsInput, alt?: string): string {
  const validDate = dayjs(time).isValid()
  return time
    ? validDate
      ? dayjs(time).format('LT')
      : dayjs(`2020-01-01 ${time}`).format('LT')
    : alt
    ? alt
    : ''
}
// Phone
export function formatPhone(value: number): string {
  const cleaned = `${value}`.replace(/\D/g, ''),
    match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/),
    formatter = match ? `(${match[1]}) ${match[2]}-${match[3]}` : ''
  return value ? formatter : ''
}
// Currency
export function formatCurrency(value: number, digits?: number): string {
  const precision = digits != undefined ? digits : 2,
    formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    })
  return typeof value === 'number' ? formatter.format(value) : ''
}
// Percent
export function formatPercent(value: number | string, digits?: number): string {
  const precision = digits != undefined ? digits : 2
  return typeof value == 'number' && (value != null || value != undefined)
    ? `${(value * 100).toFixed(precision)}%`
    : typeof value == 'string'
    ? value
    : ''
}
// File Size
export function formatFileSize(value: number): string {
  const precision = 2,
    bytes = value,
    kb = 1024,
    mb = kb * 1024
  if (bytes >= kb && bytes < mb) {
    return `${(bytes / kb).toFixed(precision)} KB`
  } else if (bytes >= mb) {
    return `${(bytes / mb).toFixed(precision)} MB`
  } else return `${bytes} B`
}
// Number
export function formatNumber(value: number, digits?: number): string {
  const precision = digits != undefined ? digits : 0
  return typeof value === 'number'
    ? new Intl.NumberFormat('en-US', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      }).format(value)
    : ''
}
